export default __webpack_public_path__ + "static/media/Resume.c2956d0f.pdf";